export const CATEGORY_IMAGES = {
  "brownies-and-blondies": {
    url: "https://images.unsplash.com/photo-1635843945732-08f2cc685f9c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Handmade chocolate brownies stacked on baking parchment",
  },
  "cookies-and-biscuits": {
    url: "https://images.unsplash.com/photo-1783374764348-83f993576410?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Freshly baked cookies arranged on a wooden board",
  },
  "bake-at-home-cookie-dough": {
    url: "https://images.unsplash.com/photo-1603380207318-371ad12c0c0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Cookie dough ready for the oven",
  },
  "mixed-boxes": {
    url: "https://images.unsplash.com/photo-1560788843-b93c2f18a3e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "A mixed box of brownies and sweet bakes with coffee",
  },
  "seasonal-specials": {
    url: "https://images.unsplash.com/photo-1688577727939-3c065e99890b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "A stack of rich seasonal brownies in a bakery box",
  },
  "celebration-bakes": {
    url: "https://images.unsplash.com/photo-1559090337-ba4123bb1682?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "A celebration table of assorted handmade bakes",
  },
};

export const HERO_IMAGE = {
  url: "https://images.unsplash.com/photo-1688577727939-3c065e99890b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  alt: "A stack of gooey handmade chocolate brownies in a bakery box",
};

export const GRAZING_IMAGE = {
  url: "https://images.unsplash.com/photo-1559090337-ba4123bb1682?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  alt: "A dessert table of cakes, bakes and sweet treats laid out for an event",
};
